import React from "react"
import { Container, Row, Col, Button } from "react-bootstrap"
import HeaderNew from "../components/HeaderNew"
import FooterCarousel from "../components/FooterCarousel";

const HomePageNew = () => {
  return (
    <>
      {/*<HeaderCarousel/>*/}

      <Container fluid>
        <Row>
          <Col>
            <div
              style={{
                backgroundImage: "url(/images/DJI_0394-Editar.jpg)",
                height: "100vh",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <HeaderNew />
            </div>
          </Col>
        </Row>
       
        <Row>
          <Col>
          <div
          style={{backgroundColor:"#CC9D33",
          height: "30vh",
          position: "relative"}}>
              <p
              style={{color:"white",
              fontFamily: "Verdana, sans-serif",
              fontSize:"x-large",
              position: "absolute",
              top: "50px",
              left: "30%"}}>
              DISCOVER BAJA IN STYLE:
              </p>
              <p
              style={{color:"white",
              fontFamily: "Verdana, sans-serif",
              fontSize:"x-large",
              position: "absolute",
              top: "100px",
              left: "40%"}}>
              YOUR LUXURY JOURNEY AWAITS!
              </p>
          </div>           
          </Col>
        </Row>
       
        <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
                          }}>                      
        <Row>
            <Col sm={12} md={6} lg={6} xl={6}> 
              <div
                style={{
                  backgroundImage: "url(/images/_MG_6926.jpg)",
                  height: "100vh",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
              >
              </div>
            </Col>        
            <Col sm={12} md={6} lg={6} xl={6}>
              <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
              padding: "24% 0",
                          }}>
                <p
                  style={{color:"black",
                  fontFamily: "Verdana, sans-serif",
                  fontSize:"x-large",
                  }}>
                  01.  ABOUT US
                </p>
                <p
                  style={{color:"#5C616B",
                  fontFamily: "Lucida Sans Unicode, sans-serif",
                  fontSize:"small",
                  }}>
                  We take great pride in being the premier transportation provider in Los Cabos, favored by travelers who frequent the stunning beaches of Cabo year after year. We offer a wide range of transportation services, from cost-effective options to luxurious limousines. Our dedicated team goes above and beyond to accommodate all special requirements, constantly striving to surpass our customers’ expectations.
Our commitment is to deliver efficient, punctual, and courteous service, ensuring a delightful travel experience for all.
                </p>
                <p
                  style={{color:"black",
                  fontFamily: "Arial, sans-serif",
                  fontSize:"small",
                  }}>
                  Unlock the Best of Baja California Sur with the Pioneers in adventure and luxury travel!
                </p> 
                <p>
                  <Button>Read More</Button>
                </p>                               
              </div>
            </Col>        
        </Row> 
       
        <Row>
            <Col sm={12} md={6} lg={6} xl={6}> 
            <div style={{backgroundColor:"#CC9D33",
             textAlign: "center",
              padding: "30% 10%",
              height: "50vh",
                          }}>
                              <p
                  style={{color:"white",
                  fontFamily: "Verdana, sans-serif",
                  fontSize:"small",
                  }}>
                  Unlock the Best of Baja California Sur with the Pioneers in adventure and luxury travel!
                </p>
            </div>
            </Col>        
            <Col sm={12} md={6} lg={6} xl={6}>
            <div style={{
                  backgroundImage: "url(/images/_MG_6941.jpg)",
                  height: "50vh",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
              >
              </div>                               
            </Col>        
        </Row>  
        </div>

        <Row>
          <Col>
          <video controls width="100%">
            <source src="https://ctsarchivos.s3.us-west-1.amazonaws.com/Cabo+Travel+Solutions+.mov" type="video/mp4"/>
                Sorry, your browser doesn't support videos.
            </video>
          </Col>
        </Row>

        <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
                          }}>
        <Row>
          <Col sm={12} md={6} lg={6} xl={6}>
              <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
              padding: "35% 0",
                          }}>
                <p
                  style={{color:"black",
                  fontFamily: "Verdana, sans-serif",
                  fontSize:"x-large",
                  }}>
                  02.  SERVICES
                </p>                          
              </div>
          </Col>   
          <Col sm={12} md={6} lg={6} xl={6}>
            <div style={{ textAlign: "center",
            backgroundColor:"#FFFAE6",
            padding: "0 0",
                        }}>
          <Row>
          <Col sm={12} md={6} lg={6} xl={6}>
          
            <div style={{ textAlign: "center",
            backgroundColor:"#FFFAE6",
            padding: "24% 0",
                        }}>                            
              <p
                style={{color:"black",
                fontFamily: "Verdana, sans-serif",
                fontSize:"large",
                }}>
                01. OUR VEHICLES
              </p>
              <div style={{
                backgroundImage: "url(/images/_MG_6980-Mejorado-NR.jpg)",
                height: "50vh",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
            </div> 
              </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div style={{ textAlign: "center",
            backgroundColor:"#FFFAE6",
            padding: "24% 0",
                        }}>    
              <p
                style={{color:"#5C616B",
                fontFamily: "Lucida Sans Unicode, sans-serif",
                fontSize:"small",
                }}>
                Choose between our different cars selected for your comfort, allowing you to enjoy your trip and don’t worry about any logistic issues.
              </p>
              <p>
                <Button>Read More</Button>
              </p>  
              </div>
          </Col> 
          </Row>                            
            </div>
          </Col>    
     
        </Row> 

        <Row>
        <Col sm={12} md={6} lg={6} xl={6}>
              <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
              padding: "0 0",
                          }}>
            <Row>
            <Col sm={12} md={6} lg={6} xl={6}>
            
            <div style={{ textAlign: "center",
            backgroundColor:"#FFFAE6",
            padding: "24% 0",
                        }}>                            
              <p
                style={{color:"black",
                fontFamily: "Verdana, sans-serif",
                fontSize:"large",
                }}>
               02. OUR DESTINATIONS
              </p>
              <div style={{
                backgroundImage: "url(/images/_MG_6980-Mejorado-NR.jpg)",
                height: "50vh",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
            </div> 
              </div>
          </Col>
          <Col sm={12} md={6} lg={6} xl={6}>
            <div style={{ textAlign: "center",
            backgroundColor:"#FFFAE6",
            padding: "24% 0",
                        }}>    
              <p
                style={{color:"#5C616B",
                fontFamily: "Lucida Sans Unicode, sans-serif",
                fontSize:"small",
                }}>
                From the serene beauty of La Paz to the spectacular nature of Loreto, these ﬁrst-class vehicles will take you to each destination
              </p>
              <p>
                <Button>Read More</Button>
              </p>  
              </div>
          </Col> 
            <Col sm={12} md={6} lg={6} xl={6}>
              <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
              padding: "0 0",
                          }}>     
                </div>
            </Col> 
            </Row>                            
              </div>
        </Col>         
        <Col sm={12} md={6} lg={6} xl={6}>
              <div style={{ textAlign: "center",
              backgroundColor:"#FFFAE6",
              padding: "45% 0",
                          }}>
              </div>
        </Col>        
        </Row> 
        </div> 

        <Row>
          <Col>
               <FooterCarousel/>
          </Col>
        </Row>                  
                       
      </Container>
    </>
             
  )
}

export default HomePageNew
